import { ReactComponent as LogoImage } from "../../assets/Logo.svg";
import styles from "../../constants/styles";

const Logo = () => {
  return (
    <div className="flex flex-row space-x-4 items-center">
      <svg className="w-[50px] md:w-[80px] h-[50px] md:h-[80px] object-contain">
        <LogoImage />
      </svg>
      <h2 className={`${styles.tertiaryHeading} text-green-500`}>Downloader</h2>
    </div>
  );
};

export default Logo;
